import { type ProjectId } from '@littlebird/sdk';
import { makeAutoObservable } from 'mobx';

import { ALL_MEETINGS_FILTER, type MeetingsFilter } from './meetings-filter';

export const NO_PROJECT_SLICE = 'no-project';

class MeetingsSidebarStore {
  projectsExpanded = true;
  circlesExpanded = true;
  recurringExpanded = true;
  projectsWithNotesOnly = false;
  projectSlice: string | null = null;
  circleKey: string | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get filter(): MeetingsFilter {
    if (this.projectSlice === NO_PROJECT_SLICE) return { kind: 'no-project' };
    return this.projectSlice
      ? { kind: 'project', projectId: this.projectSlice as ProjectId }
      : ALL_MEETINGS_FILTER;
  }

  get hasSlice() {
    return this.circleKey !== null || this.projectSlice !== null;
  }

  selectCircle(circleKey: string) {
    this.circleKey = circleKey;
    this.projectSlice = null;
  }

  selectProjectSlice(projectSlice: string) {
    this.projectSlice = projectSlice;
    this.circleKey = null;
  }

  clearSlice() {
    this.circleKey = null;
    this.projectSlice = null;
  }

  setRecurringExpanded(expanded: boolean) {
    this.recurringExpanded = expanded;
  }

  setCirclesExpanded(expanded: boolean) {
    this.circlesExpanded = expanded;
  }

  setProjectsExpanded(expanded: boolean) {
    this.projectsExpanded = expanded;
  }

  setProjectsWithNotesOnly(withNotesOnly: boolean) {
    this.projectsWithNotesOnly = withNotesOnly;
  }
}

export const meetingsSidebarStore = new MeetingsSidebarStore();
